export default "__VITE_ASSET__D0em3qBe__"